export const secondsToDay = (s: number) => Math.floor(s / (24 * 60 * 60))
